import type { JSX, ReactNode } from 'react'
import type { CardAnimations } from '../Card.h'

import { AnimatedWrapper } from 'blocks/AnimatedWrapper'
import { TVCardContent, TVCardFavoriteSC } from './TVCardDefault.styled'

export interface ITVCardHoverContentProps {
  favoriteChildren: ReactNode
  hoverContent: ReactNode
  viewedButtonFavorite?: boolean
  aclBlockedBy?: boolean
  childrenTransition?: CardAnimations
  hoverTrigger: boolean
}

/** My-list stays outside BaseCard's fade-in wrapper (FP-4392). */
export const TVCardHoverContent = ({
  favoriteChildren,
  hoverContent,
  viewedButtonFavorite = true,
  aclBlockedBy = false,
  childrenTransition,
  hoverTrigger,
}: ITVCardHoverContentProps): JSX.Element => {
  const body = <TVCardContent>{hoverContent}</TVCardContent>

  return (
    <>
      {!aclBlockedBy && (
        <TVCardFavoriteSC
          viewedButtonFavorite={viewedButtonFavorite}
          showOnHover={hoverTrigger}
        >
          {favoriteChildren}
        </TVCardFavoriteSC>
      )}
      {childrenTransition ? (
        <AnimatedWrapper
          transitionName={childrenTransition}
          transitionTrigger={hoverTrigger}
        >
          {body}
        </AnimatedWrapper>
      ) : (
        body
      )}
    </>
  )
}
